class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.searchOverlay = document.getElementById('search-overlay');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.querySelector('.modal__close-button').addEventListener(
      'click',
      (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      }
    );

    this.summaryToggle.setAttribute('role', 'button');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    
    event.preventDefault();

    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target)) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    this.summaryToggle.setAttribute('aria-expanded', 'true');
    document.body.addEventListener('click', this.onBodyClickEvent);

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    this.toggleOverlay(event);
  }

  close(focusToggle = true) {
    this.detailsContainer.removeAttribute('open');
    this.summaryToggle.setAttribute('aria-expanded', 'false');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    if (this.searchOverlay) this.searchOverlay.removeAttribute('open');
    this.querySelectorAll('predictive-search').forEach((search) => search.close(true));
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
  }

  toggleOverlay(event) {
    if(!this.searchOverlay) return;
    
    if(this.searchOverlay.hasAttribute('open')) {
      this.searchOverlay.removeAttribute('open')
    } else if(!this.searchOverlay.hasAttribute('open') && event) {
      this.searchOverlay.setAttribute('open', '')
    }
  }
}

customElements.define('details-modal', DetailsModal);
